import React, { Component } from 'react'
import { TableRow, TableCell, Link } from '@aws-amplify/ui-react';
import { Trash } from 'react-bootstrap-icons';

class ContractReviewRow extends Component {
    formatSize(size) {
        if (1024 <= size && size < 1024 ** 2)
            return `${size / 1024 >> 0} KB`;
        else if (1024 ** 2 <= size && size < 1024 ** 3)
            return `${size / 1024 ** 2 >> 0} MB`;
        else if (1024 ** 3 <= size)
            return `${Math.round(size * 10 / 1024 ** 3) / 10} GB`
    };

    render() {
        return (
            <React.Fragment>
                <TableRow>
                    <TableCell>
                        <input type="radio" name="selectProject" key={this.props.entity.project_id} onChange={() => this.props.onSelectChange(this.props.entity)} />
                    </TableCell>
                    <TableCell>
                        {this.props.entity.project_id}
                    </TableCell>
                    <TableCell>
                        {this.props.entity.file_count}
                    </TableCell>
                    <TableCell>
                        {this.formatSize(this.props.entity.size)}
                    </TableCell>
                    <TableCell>
                        <Link className='App-link text-center' onClick={() => this.props.onDelete(this.props.entity)}>
                            <Trash/>
                        </Link>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        )
    }
}
export default ContractReviewRow;